import React from "react";
import { Card, Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import { SiQualys } from "react-icons/si";
import { FaWpbeginner } from "react-icons/fa6";
import { RiShoppingBag3Fill } from "react-icons/ri";
import { FaCartArrowDown } from "react-icons/fa6";
import { FaIndustry } from "react-icons/fa";
import { MdEmojiTransportation } from "react-icons/md";
import { IoIosConstruct } from "react-icons/io";
import { MdHealthAndSafety } from "react-icons/md";
import { MdNetworkWifi } from "react-icons/md";
import { MdOutlineSecurity } from "react-icons/md";
const cardStyle = {
  background: "linear-gradient(135deg, #1c1c1c, #2b2b2b, #111)",
  color: "#e6e6e6",
  borderRadius: "18px",
  boxShadow: "0 8px 20px rgba(0,0,0,0.6)",
  position: "relative",
  overflow: "hidden",
};

// Animation variants
const fadeUp = {
  hidden: { opacity: 0, y: 60 },
  visible: { opacity: 1, y: 0 },
};

const Provide = () => {
 const cards = [
  { 
    icon: <FaCartArrowDown  size={80} style={{ color: "#1cd3e7ff" }} />, 
    title: "Ports & Logistics", 
    hoverText: "Automate gate-to-yard operations with AI that counts wagons, detects cargo, and ensures safety compliance." 
  },
  { 
    icon: <FaIndustry  size={80} style={{ color: "#1cd3e7ff" }} />, 
    title: "Manufacturing & Industrial Plants", 
    hoverText: "Ensure PPE compliance, detect fire or smoke, and monitor restricted zones for a safer, automated environment." 
  },
  { 
    icon: <MdEmojiTransportation size={80} style={{ color: "#1cd3e7ff" }} />, 
    title: "Transportation & Smart Infrastructure", 
    hoverText: "Enable AI-powered tracking, speed violation detection, and ANPR systems for smarter, safer mobility networks." 
  },
  { 
    icon: <IoIosConstruct size={80} style={{ color: "#1cd3e7ff" }} />, 
    title: "Construction & Infrastructure", 
    hoverText: "Use AI oversight to detect safety breaches, track worker movement, and automate compliance with precision." 
  },
  { 
    icon: <RiShoppingBag3Fill size={80} style={{ color: "#1cd3e7ff" }} />, 
    title: "Retail & E-Commerce", 
    hoverText: "Empower shopping experiences with virtual try-ons, customer analytics, and intelligent product recommendations." 
  },
  { 
    icon: <MdHealthAndSafety  size={80} style={{ color: "#1cd3e7ff" }} />, 
    title: "Healthcare", 
    hoverText: "Leverage AI to predict diseases from medical imagery, aiding doctors with early, data-driven diagnosis." 
  },
  { 
    icon: <MdNetworkWifi size={80} style={{ color: "#1cd3e7ff" }} />, 
    title: " ⁠Media & Broadcasting", 
    hoverText: "Redefining storytelling with synthetic intelligence AI anchors read, gesture, and engage like humans — revolutionizing how news and content are delivered." 
  },
  { 
    icon: <MdOutlineSecurity size={80} style={{ color: "#1cd3e7ff" }} />, 
    title: "Corporate & Enterprise Security", 
    hoverText: "Face recognition, access management, and document automation — all powered by Foxtroit AI. We bring intelligence to identity and compliance" 
  }
];
  return (

  <section
  style={{
    background: "linear-gradient(135deg, #dc94d5ff, #efe9e9ff, #a0d6f1ff)",
  }}
  className="py-5"
>
  <motion.h1
    className="text-center mt-4 fw-bold mb-5"
    style={{
      fontFamily: "'Roboto', sans-serif",
      fontSize: "2.8rem",
      letterSpacing: "0.5px",
      lineHeight: "1.3",
      textTransform: "uppercase",
      color: "black",
    }}
    initial={{ opacity: 0, y: -40 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8 }}
    viewport={{ once: false }}
  >
    Industries We Serve
  </motion.h1>

  <Container>
    <Row>
      {cards.map((c, i) => (
        <Col key={i} md={4} lg={3} className="mb-4 d-flex justify-content-center">
          <motion.div
            style={cardStyle}
            className="card-hover d-flex align-items-center justify-content-center mt-4 mb-4"
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            transition={{ duration: 0.7, delay: i * 0.2 }}
            viewport={{ once: false }}
          >
            <Card.Body
              className="text-center d-flex flex-column align-items-center justify-content-center"
              style={{ height: "100%" }}
            >
              <div>
                <span>{c.icon}</span>
                <Card.Title
                  className="fs-4 mt-4 text-light"
                  style={{ fontWeight: "600", lineHeight: "1.4" }}
                >
                  {c.title}
                </Card.Title>
              </div>
            </Card.Body>

            {/* Hover Overlay */}
            <div className="overlay">
              <p className="text-light h6">{c.hoverText}</p>
            </div>
          </motion.div>
        </Col>
      ))}
    </Row>
  </Container>

  {/* CSS */}
  <style>
    {`
      .card-hover {
        position: relative;
        background: rgba(0, 0, 0, 0.75);
        border-radius: 18px;
        padding: 25px;
        text-align: center;
        color: white;
        height: 320px; 
        width: 100%;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
        transition: transform 0.3s ease, box-shadow 0.3s ease;
        overflow: hidden;
      }

      .card-hover:hover {
        transform: translateY(-8px);
        box-shadow: 0 6px 25px rgba(0, 0, 0, 0.3);
      }

      .card-hover .overlay {
        position: absolute;
        inset: 0;
        background: rgba(0, 0, 0, 0.6);
        backdrop-filter: blur(4px);
        border-radius: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        transition: opacity 0.4s ease-in-out;
        text-align: center;
        padding: 20px;
      }

      .card-hover:hover .overlay {
        opacity: 1;
      }

      @media (max-width: 768px) {
        .card-hover {
          height: 280px;
        }
      }
    `}
  </style>
</section>


  );
};

export default Provide;
